import * as React from "react";
import portfolioData from "../../../static/data.json";

export const Context = React.createContext({});

export function ContextProvider({ children }: { children: any }) {
  const [loaded, setLoaded] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [hidden, setHidden] = React.useState({});
  const [data] = React.useState(portfolioData);

  function toggleHidden(el: string) {
    //@ts-ignore
    const change = hidden[el] ? false : true;
    setHidden({ ...hidden, [el]: change });
  }

  return <Context.Provider value={{ loaded, loading, data, hidden, toggleHidden }}>{children}</Context.Provider>;
}
